<script>
import { mapActions } from 'vuex';
import mainViewTabMixin from '../../mixins/mainViewTab';
import snackbarMixin from '../../mixins/snackbar';
import UserBasicInfoForm from './components/UserBasicInfoForm';
import History from '../history';

export default {
  name: 'UserDetails',
  components: {
    UserBasicInfoForm,
    History,
  },
  mixins: [mainViewTabMixin, snackbarMixin],
  data() {
    return {
      query: {},
      params: {},
      user: {},
      isLoading: false,
      isSaving: false,
      hasError: false,
      activeTab: 0,
    };
  },
  created() {
    const { query, params } = this.urlParser('/user/show/:id?', this.path);

    this.query = query;
    this.params = params;
    this.fetchData();
  },
  methods: {
    ...mapActions('userDetails', ['fetchUser', 'saveUser']),
    fetchData() {
      this.isLoading = true;
      this.hasError = false;

      return this.fetchUser(this.params.id)
        .then(({ data }) => {
          this.user = data;

          if (this.user.isProcedureDirectoryResponsible) {
            this.user.roleStatus = 1;
          } else if (this.user.isAdmin) {
            this.user.roleStatus = 2;
          } else {
            this.user.roleStatus = 0;
          }

          this.updateTabTitle({ path: this.path, title: this.user.username });
        })
        .catch(() => {
          this.hasError = true;
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    save() {
      this.isSaving = true;

      this.user.isProcedureDirectoryResponsible = this.user.roleStatus === 1;
      this.user.isAdmin = this.user.roleStatus === 2;
      console.log('isAdmin', this.user.isAdmin);

      return this.saveUser(this.user)
        .then(() => {
          this.fetchData();
          this.showSuccessMessage('Der Benutzer wurde erfolgreich gespeichert!');
        })
        .catch(() => {
          this.showErrorMessage('Der Benutzer konnte nicht gespeichert werden. Bitte versuche es erneut!');
        })
        .finally(() => {
          this.isSaving = false;
        });
    },
  },
};
</script>

<template>
  <div class="user-detail">
    <v-progress-linear v-if="isLoading" :indeterminate="true"/>

    <span
      v-else-if="hasError"
      class="js-error ma-3"
    >An error occurred while fetching user information</span>

    <template v-else>
      <v-toolbar dark dense height="40" color="blue-grey lighten-2">

        <v-tooltip bottom>
          <v-btn @click="fetchData" icon slot="activator">
            <v-icon>refresh</v-icon>
          </v-btn>
          <span>Aktualisieren</span>
        </v-tooltip>

        <v-tooltip bottom>
          <v-btn @click="save" :loading="isSaving" icon slot="activator">
            <v-icon>save</v-icon>
          </v-btn>
          <span>Speichern</span>
        </v-tooltip>
      </v-toolbar>

      <v-form>
        <v-container fluid grid-list-lg pt-2 pa-0>
          <v-tabs v-model="activeTab" height="35" slider-color="black" color="amber">
            <v-tab ripple>Stammdaten</v-tab>
            <v-tab ripple>Historie</v-tab>
            <v-tab-item>
              <UserBasicInfoForm :user="user"/>
            </v-tab-item>
            <v-tab-item>
              <History :domain="'user'" :domain-id="user.id" path="/history" />
            </v-tab-item>
          </v-tabs>
        </v-container>
      </v-form>
    </template>
  </div>
</template>

<style lang="scss">
.user-detail {
  &-title {
    margin-bottom: 10px;
  }

  &-actions {
    margin: 5px 0;

    .v-btn:first-child {
      border-radius: 5px 0 0 5px;
    }

    .v-btn:last-child {
      border-radius: 0 5px 5px 0;
    }

    .v-btn + .v-btn {
      border-left: 1px solid #fff !important;
    }

    .v-btn {
      margin: 0;
      width: 35px;
      height: 35px;
      border-radius: 0px;
    }
  }

  &-tab {
    padding-top: 10px;

    &-title {
      margin-bottom: 10px;
    }
  }

  &-common-list {
    margin-top: 5px;
    .v-btn {
      margin: 0px;
      width: 30px;
      height: 30px;
    }

    &-title {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 10px;
    }

    &-item {
      display: flex;
      align-items: center;
      justify-content: space-between;

      &:hover {
        .v-btn {
          opacity: 1;
        }
      }

      .v-btn {
        opacity: 0;
      }
    }
  }

  .v-tabs {
    &__items {
      padding-bottom: 30px;
    }
  }

  .submit-button {
    margin-top: 20px;
  }
}
</style>
